import axios from "axios"
import { ServerEnv } from "../models/serverEnv"

class EnvUtils {
    /**
     * Recupère la taile de la window
     */
    public static getScreenSize(customeDoc?: HTMLElement): {
        x: number
        y: number
    } {
        if (customeDoc) {
            const x = customeDoc.clientWidth || customeDoc.clientWidth
            const y = customeDoc.clientHeight || customeDoc.clientHeight
            return { x, y }
        }
        const win = window
        const doc = document
        const docElem = doc.documentElement
        const body = doc.getElementsByTagName("body")[0]
        const x = win.innerWidth || docElem.clientWidth || body.clientWidth
        const y = win.innerHeight || docElem.clientHeight || body.clientHeight

        return { x, y }
    }
    /**
     * Recupère le nom du platform
     */
    public static getPlatform(): "web" | "mobile" {
        if (!window?.localStorage) return "mobile"
        return "web"
    }

    /**
     * Recupère l'env du backend
     */
    public static getServerEnv(): Promise<ServerEnv> {
        const promise = new Promise<ServerEnv>((resolve, reject) => {
            axios.get(`${process.env.REACT_APP_API_BASE_URL}`).then(
                (res) => resolve(res?.data),
                (err) => reject(err)
            )
        })
        return promise
    }
}

export default EnvUtils
